import request from '@/providers/http-service'
const url = `${process.env.VUE_APP_API_DOMAIN}/unified-code`


// 值班月历
export function zhibanMonth(params) {
  return request({
    url: url + '/extend-zhiban/zhibanMonth',
    method: 'get',
    params
  })
}
// 值班月历导入
export function importZhiban(params) {
  return request({
    url: url + '/extend-zhiban/importZhiban',
    method: 'post',
    data: params
  })
}
// 值班打卡
export function dutyLogjoinPage(params) {
  return request({
    url: url + '/extend-zhiban/dutyLogjoinPage',
    method: 'post',
    data: params
  })
}
// 导出
export function dutyLogExp(params) { //
  return request({
    url: url + '/extend-zhiban/dutyLogExp ',
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}
// 导出列表
export function dutyLogJoinExp(params) { //
  return request({
    url: url + '/extend-zhiban/dutyLogJoinExp',
    method: 'post',
    data: params,
    responseType: 'blob',
  })
}

// 值班详情
export function fillDutyLogDetail(params) {
  return request({
    url: url + '/extend-zhiban/fillDutyLogDetail',
    method: 'get',
    params
  })
}
// 配置详情
export function mangerDetail(params) {
  return request({
    url: url + '/gh-event-manger/detail?id=ZHIBAN',
    method: 'get',
    params
  })
}
// 打卡配置
export function mangerEdit(params) {
  return request({
    url: url + '/gh-event-manger/edit',
    method: 'post',
    data: params
  })
}
// 配置详情
export function changeState(params) {
  return request({
    url: url + '/gh-event-manger/changeState',
    method: 'get',
    params
  })
}

// 社区
export function mySqDept(params) {
  return request({
    url: url + '/extendHome/mySqDept',
    method: 'get',
    params
  })
}


// WEBPACK FOOTER //
// ./src/api/onDutyAndStandBy.js